
import { useState, useEffect } from 'react';
import HvacNavbar from './components/HvacNavbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import About from './components/About';
import PainPoints from './components/PainPoints';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import Contact from './components/Contact';

export default function HvacPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <HvacNavbar />
      <main className="min-h-screen bg-white">
        <Hero />
        <PainPoints />
        <About />
        <Testimonials />
        <Pricing />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
